import { Injectable } from '@angular/core';
import { CldrIntlService } from '@progress/kendo-angular-intl';

@Injectable()
export class FirstDayIntlService extends CldrIntlService {
  public firstDay(): number {
    return 1;
  }
}
